/**
 * Trạng thái task
 * NVTUAN1 18.12.2023
 */
export default {
  Waiting: 0, //Đợi worker chạy
  Running: 1, //Đang chạy
  Success: 2, //Thành công
  Fail: 3 //Lỗi
};
